module.exports = __webpack_public_path__ + "media/images/wfc/venue-1-15cfde0b8db2221dcfcf9e414e29f421.jpg";